document.addEventListener('DOMContentLoaded', () => {
    const RECENTLY_VIEWED_KEY = 'store_recently_viewed_products';
    const MAX_RECENTLY_VIEWED = 10;

    function getRecentlyViewedProducts() {
        try {
            const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            console.error('Error reading recently viewed products:', e);
            return [];
        }
    }

    function saveRecentlyViewedProduct(productHandle) {
        if (!productHandle) return;

        let handles = getRecentlyViewedProducts();
        handles = handles.filter(h => h !== productHandle);
        handles.unshift(productHandle);
        handles = handles.slice(0, MAX_RECENTLY_VIEWED);

        try {
            localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(handles));
        } catch (e) {
            console.error('Error saving recently viewed product:', e);
        }
    }

    function trackProductView() {
        if (document.body.classList.contains('product')) {
            const pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
            if (pathMatch && pathMatch[1]) {
                saveRecentlyViewedProduct(pathMatch[1]);
            }
        }
    }

    function getCurrentProductHandle() {
        const pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        return pathMatch && pathMatch[1] ? pathMatch[1] : null;
    }

    async function renderRecentlyViewedProducts(
        sectionSelector = '#recently-viewed-products-section',
        containerSelector = '#recently-viewed-products-list',
        loaderSelector = '#recently-viewed-products-loader'
    ) {
        const section = document.querySelector(sectionSelector);
        const container = document.querySelector(containerSelector);
        if (!section || !container) return;

        section.classList.add('hidden');

        let handles = getRecentlyViewedProducts();

        const currentHandle = getCurrentProductHandle();
        if (currentHandle && sectionSelector === '#product-recently-viewed-section') {
            handles = handles.filter(h => h !== currentHandle);
        }

        if (handles.length === 0) {
            section.classList.add('hidden');
            return;
        }

        const loader = document.querySelector(loaderSelector);
        if (loader) {
            loader.classList.remove('hidden');
            loader.classList.add('flex');
        }
        if (container) {
            container.classList.add('hidden');
        }

        let url = null;
        try {
            const handlesParam = handles.join(',');
            url = new URL(window.location.origin + '/pages/pickleball');
            url.searchParams.set('sections', 'recently-viewed-products');
            url.searchParams.set('handles', handlesParam);

            const response = await fetch(url.toString());
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const responseData = await response.json();

            let sectionHTML = responseData['recently-viewed-products'] ||
                responseData['recently-viewed'] ||
                responseData['shopify-section-recently-viewed-products'] ||
                responseData['shopify-section-recently-viewed'] ||
                '';

            if (!sectionHTML && Object.keys(responseData).length > 0) {
                for (const key of Object.keys(responseData)) {
                    const value = responseData[key];
                    if (value === null) continue;
                    if (key.includes('recently-viewed') || key.includes('recently_viewed') ||
                        key.match(/shopify-section-.*__recently-viewed/i)) {
                        sectionHTML = value;
                        break;
                    }
                }
                if (!sectionHTML) {
                    for (const key of Object.keys(responseData)) {
                        if (responseData[key] !== null) {
                            sectionHTML = responseData[key];
                            break;
                        }
                    }
                }
            }

            if (!sectionHTML || sectionHTML.trim().length === 0) {
                throw new Error('No section data returned');
            }

            if (sectionHTML.includes('No recently viewed products') ||
                sectionHTML.includes('No recently viewed')) {
                section.classList.add('hidden');
                if (loader) loader.classList.add('hidden');
                return;
            }

            if (sectionHTML.includes('<html') || sectionHTML.includes('<head') || sectionHTML.includes('<body')) {
                throw new Error('Invalid response: received full page HTML');
            }

            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionHTML, 'text/html');

            let contentWrapper = doc.querySelector('#recently-viewed-products-content') ||
                doc.querySelector('.recently-viewed-products-content');

            if (!contentWrapper) {
                const sectionWrapper = doc.querySelector('#shopify-section-recently-viewed-products') ||
                    doc.querySelector('[id*="recently-viewed"]') ||
                    doc.querySelector('[id*="recently_viewed"]') ||
                    doc.querySelector('section.shopify-section');
                if (sectionWrapper) {
                    contentWrapper = sectionWrapper.querySelector('#recently-viewed-products-content') ||
                        sectionWrapper.querySelector('.recently-viewed-products-content');
                }
            }

            if (!contentWrapper && doc.body) {
                contentWrapper = doc.body.querySelector('#recently-viewed-products-content') ||
                    doc.body.querySelector('.recently-viewed-products-content');
            }

            let content = '';
            if (contentWrapper?.innerHTML.trim()) {
                content = contentWrapper.innerHTML.trim();
            } else if (doc.body) {
                const slides = doc.body.querySelectorAll('.embla__slide');
                if (slides.length > 0) {
                    content = Array.from(slides).map(slide => slide.outerHTML).join('');
                }
            }

            if (content && content.length > 0) {
                container.innerHTML = content;
                container.classList.remove('hidden');
                if (loader) loader.classList.add('hidden');

                const validProducts = container.querySelectorAll('.embla__slide');
                const productCount = validProducts.length;

                if (productCount === 0) {
                    section.classList.add('hidden');
                    return;
                }

                section.classList.remove('hidden');

                setTimeout(() => {
                    if (typeof window.initializeProductCardVariants === 'function') {
                        window.initializeProductCardVariants(container);
                    }
                }, 100);
            } else {
                if (loader) loader.classList.add('hidden');
                section.classList.add('hidden');
            }
        } catch (e) {
            console.error('Error rendering recently viewed products:', e);
            console.error('Failed URL:', url?.toString() || 'N/A');
            if (loader) loader.classList.add('hidden');
            section.classList.add('hidden');
        }
    }

    if (document.body.classList.contains('product')) {
        trackProductView();
        renderRecentlyViewedProducts(
            '#product-recently-viewed-section',
            '#product-recently-viewed-list',
            '#product-recently-viewed-loader'
        );
    }

    document.addEventListener('click', (e) => {
        const productCard = e.target.closest('.product-card[data-product-id]');
        if (productCard) {
            const productDataScript = productCard.querySelector('.product-card-data');
            if (productDataScript) {
                try {
                    const productData = JSON.parse(productDataScript.textContent);
                    if (productData && productData.handle) {
                        saveRecentlyViewedProduct(productData.handle);
                    }
                } catch (e) {
                    const productLink = productCard.querySelector('a[href*="/products/"]');
                    if (productLink) {
                        const href = productLink.getAttribute('href');
                        const match = href.match(/\/products\/([^\/\?]+)/);
                        if (match?.[1]) {
                            saveRecentlyViewedProduct(match[1]);
                        }
                    }
                }
            } else {
                const productLink = productCard.querySelector('a[href*="/products/"]');
                if (productLink) {
                    const href = productLink.getAttribute('href');
                    const match = href.match(/\/products\/([^\/\?]+)/);
                    if (match?.[1]) {
                        saveRecentlyViewedProduct(match[1]);
                    }
                }
            }
        }
    });

    window.searchRecentlyViewed = {
        getRecentlyViewedProducts,
        saveRecentlyViewedProduct,
        trackProductView,
        renderRecentlyViewedProducts
    };
});

